import gql from 'graphql-tag';

export default gql`
  query integrationTypesByRemoteID($remoteID: ID!) {
    integrationTypesByRemoteID(remoteID: $remoteID)
  }
`;
